import { forwardRef, type ReactNode, type Ref } from 'react';
import { Paragraph } from '@hungryroot/ramen';
import styles from './CalloutBox.module.css';

type Props = {
  testid?: string;
  callout: string;
  image: ReactNode;
  className?: string;
};

export const CalloutBox = forwardRef(
  (props: Props, ref: Ref<HTMLDivElement>) => {
    const { testid, callout, image, className } = props;
    return (
      <div
        data-testid={testid}
        className={`${styles.container} ${className}`}
        ref={ref}
      >
        {image}
        <Paragraph variant="caption" className={styles.callout}>
          {callout}
        </Paragraph>
      </div>
    );
  }
);
